import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/common-models';
import { DynamicFormService } from '../../service/dynamic-form.service';
// import { CommonService } from '../../../services/common.service';



@Component({
  selector: 'app-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['form-select.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FormSelectComponent implements Field, OnInit {
  config: FieldConfig;
  group: FormGroup;
  FormControlName:string;
  options=[]
  constructor(){

  }
  ngOnInit(){
    this.FormControlName = this.config.name;
    this.group.controls[this.config.name].setValue(this.config.value);
  }


  reset(event){
    if(this.group.controls[this.config.name].value == ""){
      event.target.blur();
      this.group.controls[this.config.name].setValue(this.config.value)
    }
  }

  selectedOption(event){
    if (this.config.cellClick){
      this.config.cellClick(event);
    }

  }



}

